<template>
  <section class="videosection">
    <a @click="$router.back()" class="closeBtns">
      <span class="icon">
        <i class="far fa-times-circle"></i>
      </span>
    </a>
    <div class="video-container" v-if="screen === 0">
      <video-player v-if="vid1.loaded" class="vjs-custom-skin" ref="videoPlayer" :options="vid1" :playsinline="true"
        @ended="onPlayerEnded($event)"></video-player>
      <div class="videoBtns">
        <a class="button is-small" id="skipBtn" @click="screen = 1">
          <span>Build It</span>
          <span class="icon">
            <i class="fas fa-chevron-right"></i>
          </span>
        </a>
      </div>
      <div v-if="popupOpen" class="cartoon2 is-hidden-desktop">
        <div class="columns">
          <div class="column">
            <div class="scard">
              <h1 class="title">
                Would you like to complete
                <b>"{{ name }}"</b>?
              </h1>
              <div class="columns">
                <div class="column has-text-centered">
                  <img src="@/assets/img/coin.svg" alt />
                  <h3 class="subtitle">
                    Build &amp; Win
                    {{ coins }} coins.
                  </h3>
                </div>
              </div>
              <button class="btn btn-theme" @click="screen = 1">Yes</button>
              <a class="btn btn-theme" @click="router('/')">No</a>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <img src="@/assets/img/cartoon.png" class="cartoonImg" />
          </div>
        </div>
      </div>
      <div class="cartoon2 is-hidden-touch">
        <div class="columns">
          <div class="column">
            <div class="scard">
              <h1 class="title">
                Would you like to complete
                <b>"{{ name }}"</b>?
              </h1>
              <div class="columns">
                <div class="column has-text-centered">
                  <img src="@/assets/img/coin.svg" alt />
                  <h3 class="subtitle">
                    Build &amp; Win
                    {{ coins }} coins.
                  </h3>
                </div>
              </div>
              <button class="btn btn-theme" @click="screen = 1">Yes</button>
              <a class="btn btn-theme" @click="router('/')">No</a>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <img src="@/assets/img/cartoon.png" class="cartoonImg" />
          </div>
        </div>
      </div>
    </div>
    <div class="video-container" v-else-if="screen === 1">
      <video-player v-if="vid3.loaded" class="vjs-custom-skin vid2 desktop-video" ref="videoPlayer" :options="vid3"
        :playsinline="true"></video-player>
      <div class="hero desktop-video-info">
        <div class="hero-body">
          <h1 class="title">
            {{ name }}
            <span @click="share" class="shareBtn">
              <i class="fas fa-share-alt-square"></i>
            </span>
          </h1>
          <div class="separator">MORE INFO</div>
          <h3 class="title" style="font-size: 1.7rem">Parts Needed:</h3>
          <!-- new-kit-info -->
          <section class="section nkitinfo">
            <!-- Main Components -->
            <div class="parts-list">
              <div v-for="(component, index) in components" :key="'nkit' + index" class="part-card">
                <div class="part-image">
                  <img :src="component.image" :alt="component.name" />
                </div>
                <div class="part-details">
                  <div class="part-header">
                    <h3 class="part-name">{{ component.name }}</h3>
                    <button class="cart-toggle-btn" :class="{ 'in-cart': isInCart(component.shopify_data?.variant_id) }"
                      @click="toggleCart(component)">
                      <svg v-if="isInCart(component.shopify_data?.variant_id)" class="check-icon" width="20" height="20"
                        viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      <svg v-else class="plus-icon" width="20" height="20" viewBox="0 0 20 20" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 4.16666V15.8333M4.16669 10H15.8334" stroke="white" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </button>
                  </div>
                  <p v-if="component.shopify_data?.price" class="part-price">₹{{ component.shopify_data.price }} per
                    unit</p>
                  <div class="part-quantity">× {{ component.qty }}</div>
                </div>
              </div>
            </div>

            <!-- Alternative Components -->
            <div v-if="altComponents.length > 0" class="alt-components">
              <div class="separator">OR</div>
              <div class="parts-list">
                <div v-for="(component, index) in altComponents" :key="'alt-' + index" class="part-card">
                  <div class="part-image">
                    <img :src="component.image" :alt="component.name" />
                  </div>
                  <div class="part-details">
                    <div class="part-header">
                      <h3 class="part-name">{{ component.name }}</h3>
                      <button class="cart-toggle-btn"
                        :class="{ 'in-cart': isInCart(component.shopify_data?.variant_id) }"
                        @click="toggleCart(component)">
                        <svg v-if="isInCart(component.shopify_data?.variant_id)" class="check-icon" width="20"
                          height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <svg v-else class="plus-icon" width="20" height="20" viewBox="0 0 20 20" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 4.16666V15.8333M4.16669 10H15.8334" stroke="white" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </button>
                    </div>
                    <p v-if="component.shopify_data?.price" class="part-price">₹{{ component.shopify_data.price }} per
                      unit</p>
                    <div class="part-quantity">× {{ component.qty }}</div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- /new-kit-info -->
          <div class="kitInfo">
            <!-- code -->
            <div v-if="codeExist" class="filecontainer">
              <div class="separator">Code &amp; Other Files</div>
              <div class="files">
                <div v-for="file in files" :key="file.id" class="file">
                  <a @click="showInApp(file.url)">
                    {{ file.name }}
                  </a>
                </div>
              </div>
            </div>
            <!-- /code -->
            <!-- share -->
            <img @click="$router.push('/mentors')" style="border-radius: 10px; border: 3px solid"
              src="@/assets/img/doubtclass.gif" alt="..." />
            <div>
              <div class="columns">
                <div class="column" style="padding: 50px 25px">
                  <a @click="share" class="button is-fullwidth">Share It</a>
                </div>
              </div>
            </div>
          </div>
          <!-- btns -->
          <div class="trailerVidBtn">
            <div class="columns">
              <div class="column" style="padding-top: 0px">
                <a v-if="shopifyCartCheck.length > 0" class="button btn btn-theme" @click="openCart()" target="blank">
                  Go to cart
                </a>
              </div>
            </div>
            <div class="columns">
              <div class="column" style="padding-top: 0px">
                <button v-if="completed" class="button btn btn-theme"
                  @click="router('/upload/story/' + $route.params.id + '/' + coins)">
                  Upload Video
                </button>
                <button v-else class="button btn btn-theme" @click="checkAuthAndProceed(markComplete)"
                  v-bind:class="{ 'is-loading': btnLoading }">
                  Completed?
                </button>
              </div>
            </div>
          </div>
          <!-- /btns -->
        </div>
      </div>
      <a @click="screen = 0" class="screen2Btn">
        <span class="icon">
          <i class="fas fa-chevron-circle-left"></i>
        </span>
      </a>
    </div>
    <div class="video-container" v-else-if="screen === 2">
      <video-player v-if="vid3.loaded" class="vjs-custom-skin vid3 desktop-video" ref="videoPlayer" :options="vid3"
        :playsinline="true"></video-player>
      <div class="hero desktop-video-info">
        <div class="hero-body" style="padding: 3rem 1.5rem 0 1.5rem">
          <h1 class="title">Follow steps in the video</h1>
          <div class="columns">
            <div class="column">
              <div class="scard dark">
                <h3 class="subtitle">
                  Have you completed
                  <b>{{ name }}</b>?
                </h3>
                <a class="button" @click="checkAuthAndProceed(markComplete)" v-bind:class="{ 'is-loading': btnLoading }">Mark it
                  Complete</a>
              </div>
            </div>
            <div class="column" style="text-align: right; padding: 0.75rem 0.75rem 0rem 0.75rem">
              <img src="@/assets/img/cartoon.png" style="width: 120px; margin-right: 80px" />
            </div>
          </div>
        </div>
      </div>
      <a @click="screen = 1" class="screen3Btn">
        <span class="icon">
          <i class="fas fa-chevron-circle-left"></i>
        </span>
      </a>
    </div>
    <div style="padding: 20px" v-else-if="screen === 3">
      <img src="@/assets/img/award.png" class="congrats" />
      <h1 class="title has-text-centered" style="padding-bottom: 15px">
        Congratulations!
      </h1>

      <img src="https://i.pinimg.com/originals/ee/1f/17/ee1f179fe400a4dbfec0b70ac58478c1.gif" alt="..." />

      <h3 class="subtitle has-text-centered">
        By building this project, you have made us proud.
      </h3>

      <h3 class="subtitle has-text-centered">
        Upload your project's video to win
        <b style="color: #000000">{{ coins }} coins.</b>
      </h3>
      <a @click="router('/upload/story/' + $route.params.id + '/' + coins)" class="btn btn-theme">Upload Video</a>
      <a @click="screen = 2" class="screen3Btn">
        <span class="icon">
          <i class="fas fa-chevron-circle-left"></i>
        </span>
      </a>

      <!-- <hr /> -->
    </div>
    <transition name="fade">
      <div v-if="animation" class="addedtocart">
        <div class="container">
          <h3 class="subtitle">
            <b>{{ animation }}</b> added to cart
          </h3>
        </div>
      </div>
    </transition>
  </section>
</template>
<script>
// import { Plugins } from "@capacitor/core";
import { auth } from "@/main.js";
import { functions } from "@/main.js";
import { db } from "@/main.js";
import { Browser } from "@capacitor/browser";
import "@/assets/css/video-js.css";
import { videoPlayer } from "vue-video-player";
// import { Webengage } from "@ionic-native/webengage";
import { Share } from "@capacitor/share";
import { firestore } from "@/main.js";
import { createWebengageEvent } from "../helper";
//import VLazyImage from "v-lazy-image";

export default {
  name: "project",
  components: {
    videoPlayer
  },
  data() {
    return {
      screen: 0,
      name: "",
      orderLink: "",
      coins: "",
      popupOpen: false,
      components: [],
      altComponents: [],
      altComponentsExist: false,
      codeExist: true,
      files: [],
      useremail: "",
      sendCodeErr: "",
      sendCodeBtn: false,
      btnLoading: false,
      pid: "",
      vid1: {
        height: "100%",
        width: "100%",
        autoplay: true,
        muted: false,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [],
        poster:
          "https://surmon-china.github.io/vue-quill-editor/static/images/surmon-1.jpg",
        loaded: false,
      },
      vid2: {
        height: "100%",
        width: "100%",
        autoplay: true,
        muted: false,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [],
        poster:
          "https://surmon-china.github.io/vue-quill-editor/static/images/surmon-1.jpg",
        loaded: false,
      },
      vid3: {
        height: "100%",
        width: "100%",
        autoplay: true,
        muted: false,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [],
        poster:
          "https://surmon-china.github.io/vue-quill-editor/static/images/surmon-1.jpg",
        loaded: false,
      },
      recommendations: [],
      completed: false,
      cart: [],
      animation: "",
      similarProjects: [],
      shopifyCart: [],
      shopifyCartCheck: [],
      mainComponents: [],
      totalCost: 0,
      hasItemsInCart: false,
      shopifyPrices: {}, // To store prices keyed by product handle
      activePlayerInstance: null,
      currentOrientation: '',
    };
  },
  beforeMount() {
    if (this.$route.params.page) this.screen = Number(this.$route.params.page);
    db.collection("projects")
      .doc(this.$route.params.id)
      .get()
      .then((doc) => {
        if (doc.exists) {
          // Only track viewing if user is logged in
          if (auth.currentUser) {
            createWebengageEvent({
              uid: auth.currentUser.uid,
              eventName: "Project Viewed",
              eventData: {
                added: new Date().getTime(),
                readableDate: new Date().toLocaleString(),
                name: doc.data().name,
              },
            });
          }
          this.pid = doc.data().pid;
          this.recommendations = doc.data().recommendations;
          this.vid1.sources.push({ type: "video/mp4", src: doc.data().story });
          this.vid2.sources.push({
            type: "video/mp4",
            src: doc.data().trailer,
          });
          this.vid3.sources.push({
            type: "video/mp4",
            src: doc.data().procedure,
          });
          this.vid1.poster =
            "https://thumbnails.cloud/v1/jpg?token=16BcfdRyI2BfW1Rux&url=" +
            encodeURIComponent(doc.data().story) +
            "&size=400&mode=orig";
          this.vid2.poster =
            "https://thumbnails.cloud/v1/jpg?token=16BcfdRyI2BfW1Rux&url=" +
            encodeURIComponent(doc.data().trailer) +
            "&size=400&mode=orig";
          this.vid3.poster =
            "https://thumbnails.cloud/v1/jpg?token=16BcfdRyI2BfW1Rux&url=" +
            encodeURIComponent(doc.data().procedure) +
            "&size=400&mode=orig";
          this.name = doc.data().name;
          this.coins = doc.data().coins;
          if (this.$store.state.profile.premium)
            this.coins = doc.data().coins * 2;
          this.orderLink = doc.data().orderLink;
          doc.data().components_v2.forEach((component) => {
            db.collection("tools")
              .doc(component.id)
              .get()
              .then((doc) => {
                this.components.push({
                  name: doc.data().name,
                  link: doc.data().orderLink,
                  video: doc.data().video,
                  image: doc.data().img,
                  pid: doc.data().pid,
                  stock: doc.data().stock,
                  qty: component.qty,
                  sid: doc.data()['shopify-id'],
                  shopify_data: doc.data()['shopify_data']
                });
              });
          });
          if (doc.data().altComponents[0] == "none") {
            this.altComponentsExist = false;
          } else {
            // console.log(doc.data().altComponents[0]);
            this.altComponentsExist = true;
            doc.data().altComponents_v2.forEach((component) => {
              db.collection("tools")
                .doc(component.id)
                .get()
                .then((doc) => {
                  this.altComponents.push({
                    name: doc.data().name,
                    link: doc.data().orderLink,
                    video: doc.data().video,
                    image: doc.data().img,
                    pid: doc.data().pid,
                    qty: component.qty,
                    sid: doc.data()['shopify-id'],
                    shopify_data: doc.data()['shopify_data']
                  });
                });
            });
          }
          db.collection("projects")
            .doc(doc.id)
            .collection("files")
            .get()
            .then((files) => {
              if (files.empty) {
                this.codeExist = false;
              } else {
                files.forEach((file) => {
                  this.files.push({
                    name: file.data().name,
                    url: file.data().url,
                    id: file.id,
                  });
                });
              }
            });
          auth.onAuthStateChanged((user) => {
            this.displayName = user.displayName;
            this.useremail = user.email;
            db.collection("users")
              .doc(user.uid)
              .collection("tracking")
              .where("id", "==", this.$route.params.id)
              .get()
              .then((snap) => {
                if (snap.empty) {
                  db.collection("users")
                    .doc(user.uid)
                    .collection("tracking")
                    .add({
                      id: this.$route.params.id,
                      created: new Date().getTime(),
                      type: "project",
                    });
                }
              });
          });
          setTimeout(() => {
            this.vid1.loaded = true;
            this.vid2.loaded = true;
            this.vid3.loaded = true;
          }, 100);
        } else {
          this.router("/");
        }
      });
    this.fetchSimilarProjects();
  },
  mounted() {
    db.collection("users")
      .doc(auth.currentUser.uid)
      .collection("projects")
      .where("pid", "==", this.$route.params.id)
      .get()
      .then((project) => {
        this.completed = !project.empty;
      });
    this.fetchProductDetails();
    this.currentOrientation = window.screen.orientation.type;
    window.screen.orientation.addEventListener('change', this.handleOrientationChangeWrapper);
    this.setupVideoPlayerListeners();
  },
  beforeDestroy() {
    window.screen.orientation.removeEventListener('change', this.handleOrientationChangeWrapper);
    this.cleanupVideoPlayerListeners();
    window.screen.orientation.unlock(); // Ensure orientation is unlocked
  },
  methods: {
    router(name) {
      this.$router.push(name);
    },
    async share() {
      console.log("https://project.witblox.com/" + this.$route.params.id);
      await Share.share({
        title: "Check this project on WitBlox",
        text: "Check out this amazing project from WitBlox.",
        url: "https://project.witblox.com/" + this.$route.params.id,
        dialogTitle: "Share with friends",
      });
    },
    async showInApp(link) {
      await Browser.open({ url: link });
    },
    onPlayerEnded() {
      this.popupOpen = true;
    },
    addToCart(p) {
      console.log(p);

      this.cart.push(p.pid);
      this.animation = p.name;
      p.added = true;
      db.collection("shop-products")
        .doc(p.pid)
        .get()
        .then((product) => {
          if (product.exists) {
            db.collection("users")
              .doc(auth.currentUser.uid)
              .collection("cart")
              .where("product", "==", p.pid)
              .limit(1)
              .get()
              .then((snap) => {
                if (snap.empty) {
                  //not added in cart
                  db.collection("users")
                    .doc(auth.currentUser.uid)
                    .collection("cart")
                    .add({
                      quantity: p.qty,
                      product: p.pid,
                      added: new Date().getTime(),
                    })
                    .then(() => {
                      this.productsAdded = true;
                    });
                } else {
                  //already added in cart
                  db.collection("users")
                    .doc(auth.currentUser.uid)
                    .collection("cart")
                    .doc(snap.docs[0].id)
                    .set(
                      {
                        quantity: firestore.FieldValue.increment(1),
                        product: p.pid,
                        added: new Date().getTime(),
                      },
                      { merge: true }
                    )
                    .then(() => {
                      this.productsAdded = true;
                    });
                }
              });
          } else console.log("product doesn't exists", p.pid);
          setTimeout(() => {
            this.animation = "";
          }, 1000);
        })
        .catch((err) => {
          console.log(err);
          this.animation = "";
        });
    },
    removeFromCart(p) {
      this.cart.splice(this.cart.indexOf(p.pid), 1);
      p.added = false;
      db.collection("users")
        .doc(auth.currentUser.uid)
        .collection("cart")
        .where("product", "==", p.pid)
        .limit(1)
        .get()
        .then((snap) => {
          if (snap.empty) {
            //not added in cart
            console.log("not added in cart");
          } else {
            //already added in cart
            if (snap.docs[0].data().quantity == 1) {
              db.collection("users")
                .doc(auth.currentUser.uid)
                .collection("cart")
                .doc(snap.docs[0].id)
                .delete()
                .then(() => {
                  this.productsAdded = true;
                });
              return;
            }

            db.collection("users")
              .doc(auth.currentUser.uid)
              .collection("cart")
              .doc(snap.docs[0].id)
              .set(
                {
                  quantity: firestore.FieldValue.increment(-1),
                  product: p.pid,
                  added: new Date().getTime(),
                },
                { merge: true }
              )
              .then(() => {
                this.productsAdded = true;
              });
          }
        });
    },
    markComplete() {
      this.btnLoading = true;
      var markComplete = functions.httpsCallable("markComplete");
      markComplete({ pid: this.$route.params.id, type: "story" }).then(() => {
        createWebengageEvent({
          uid: auth.currentUser.uid,
          eventName: "Project Completed",
          eventData: {
            added: new Date().getTime(),
            readableDate: new Date().toLocaleString(),
            name: this.name,
            recommendations: this.recommendations,
          },
        });
        this.btnLoading = false;
        this.screen = 3;
      });
    },
    checkAuthAndProceed(callback) {
      // Check if user is logged in
      if (!auth.currentUser) {
        // Redirect to login page
        this.$router.push('/login');
        return;
      }
      
      // If user is authenticated, proceed with the callback
      callback();
    },
    async fetchSimilarProjects() {
      const categoriesConfig = await db
        .collection("config")
        .doc("categories")
        .get();

      const allProjects = categoriesConfig.data().recommended_projects;

      const activeProject = allProjects.find(
        (project) => project.id === this.$route.params.id
      );

      let similarProjects = allProjects.filter(
        (project) => project?.category_id === activeProject?.category_id
      );
      this.similarProjects = similarProjects;
    },
    emailCode() {
      this.sendCodeBtn = true;
      if (this.validateEmail(this.useremail)) {
        auth.onAuthStateChanged((user) => {
          var emailCode = functions.httpsCallable("emailCode");
          emailCode({
            pid: this.$route.params.id,
            uid: user.uid,
            email: this.useremail,
          }).then(() => {
            this.sendCodeBtn = false;
            this.sendCodeErr =
              "We've e-mailed you all required code & other files.";
          });
        });
      } else {
        this.sendCodeBtn = false;
        this.sendCodeErr = "Please enter a valid e-mail address.";
      }
    },
    validateEmail(email) {
      console.log(email);
      //eslint-disable-next-line
      //   const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      //   return re.test(String(email).toLowerCase());
    },
    addToShopifyCart(component) {
      this.shopifyCart.push({
        id: component.shopify_data.variant_id,
        quantity: component.qty
      });
      this.shopifyCartCheck.push(component.shopify_data.variant_id);

      // Show animation/feedback
      this.animation = component.shopify_data.product_title;
      setTimeout(() => {
        this.animation = '';
      }, 2000);
    },
    removeFromShopifyCart(component) {
      this.shopifyCart = this.shopifyCart.filter(item => item.id !== component.shopify_data.variant_id);
      this.shopifyCartCheck = this.shopifyCartCheck.filter(id => id !== component.shopify_data.variant_id);
    },
    openCart() {
      const baseUrl = `http://witblox.com/cart/`;
      const itemString = this.shopifyCart.map(item => `${item.id}:${item.quantity}`).join(',');
      this.showInApp(baseUrl + itemString + '?storefront=true&app_user_id=' + auth.currentUser.uid);
      //clear cart
      this.shopifyCart = [];
      this.shopifyCartCheck = [];
    },
    async fetchProductDetails() {
      try {
        // Update prices for main components
        this.components.forEach(component => {
          if (component.shopify_data?.price) {
            component.price = parseFloat(component.shopify_data.price);
          }
        });

        // Update prices for alternative components
        if (this.altComponents) {
          this.altComponents.forEach(component => {
            if (component.shopify_data?.price) {
              component.price = parseFloat(component.shopify_data.price);
            }
          });
        }

        // Calculate total cost
        this.calculateTotalCost();

      } catch (error) {
        console.error('Error fetching product details:', error);
      }
    },

    calculateTotalCost() {
      let total = 0;
      this.components.forEach(component => {
        if (component.shopify_data?.price && component.qty) {
          total += parseFloat(component.shopify_data.price) * component.qty;
        }
      });
      this.totalCost = total;
    },

    isInCart(sid) {
      return sid && this.shopifyCartCheck.includes(parseInt(sid));
    },
    toggleCart(component) {
      if (this.isInCart(component.shopify_data?.variant_id)) {
        this.removeFromShopifyCart(component);
      } else {
        this.addToShopifyCart(component);
      }
    },
    getActivePlayer() {
      if (this.$refs.videoPlayer && this.$refs.videoPlayer.player) {
        return this.$refs.videoPlayer.player;
      }
      return null;
    },
    setupVideoPlayerListeners() {
      this.$nextTick(() => {
        const player = this.getActivePlayer();
        if (player) {
          if (this.activePlayerInstance && this.activePlayerInstance !== player && this.activePlayerInstance.hasEventListenerForOrientation) {
            this.activePlayerInstance.off('fullscreenchange', this.handlePlayerFullscreenChange);
            this.activePlayerInstance.hasEventListenerForOrientation = false;
          }
          if (!player.hasEventListenerForOrientation) {
            player.on('fullscreenchange', this.handlePlayerFullscreenChange);
            player.hasEventListenerForOrientation = true;
          }
          this.activePlayerInstance = player;
        }
      });
    },
    cleanupVideoPlayerListeners() {
      if (this.activePlayerInstance && this.activePlayerInstance.hasEventListenerForOrientation) {
        this.activePlayerInstance.off('fullscreenchange', this.handlePlayerFullscreenChange);
        this.activePlayerInstance.hasEventListenerForOrientation = false;
        this.activePlayerInstance = null;
      }
    },
    handleOrientationChangeWrapper() {
      const newOrientation = window.screen.orientation.type;
      // Let player fullscreen changes manage orientation lock/unlock mostly.
      // This primarily reacts to enter/exit fullscreen if orientation implies it.
      // this.currentOrientation = newOrientation; // Update current orientation

      const player = this.getActivePlayer();
      if (!player) return;

      if (newOrientation.includes('landscape')) {
        if (!player.isFullscreen()) {
          player.requestFullscreen(); // This will trigger handlePlayerFullscreenChange to lock
        }
      } else if (newOrientation.includes('portrait')) {
        if (player.isFullscreen()) {
          player.exitFullscreen(); // This will trigger handlePlayerFullscreenChange to unlock
        }
      }
    },
    handlePlayerFullscreenChange() {
      const player = this.getActivePlayer();
      if (!player) return;

      if (player.isFullscreen()) {
        window.screen.orientation.lock('landscape').catch(err => {
          console.warn('Failed to lock orientation to landscape:', err);
        });
      } else {
        // When exiting fullscreen, unlock orientation.
        // If device is physically portrait, it will return to portrait.
        // If device is physically landscape, it will remain landscape (unlocked).
        window.screen.orientation.unlock();
      }
    }
  },
  watch: {
    screen() {
      this.setupVideoPlayerListeners();
    }
  }
};
</script>
<style>
.title span.shareBtn {
  padding-left: 10px;
}

.videoBtns {
  text-align: center;
}

.videoBtns .button {
  font-size: 1.2rem;
  background: #000;
  border-radius: 10px;
}

.videosection,
.video-container,
.video-player,
.vjs_video_3-dimensions,
.video-js {
  width: 100%;
  height: 100% !important;
}

.plist {
  max-width: 500px;
  margin-bottom: 20px;
}

@media only screen and (min-width: 600px) {
  .video-player.vid2 {
    height: 450px !important;
  }

  .trailerVidBtn .columns {
    max-width: 700px;
    margin: auto;
  }

  .plist {
    max-width: 500px;
    margin-bottom: 10px;
  }

  .cartoon2 {
    width: 27%;
  }
}

@media only screen and (min-width: 900px) {

  .video-container .desktop-video,
  .video-container .desktop-video-info {
    display: inline;
  }

  .video-container .desktop-video {
    width: 70%;
    height: 100% !important;
    float: left;
  }

  .video-container .desktop-video-info {
    width: 30%;
    height: 100% !important;
    float: right;
    overflow: scroll;
    position: relative;
  }

  .trailerVidBtn {
    width: 30%;
    right: 0;
    left: auto;
  }
}

.addedtocart {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgb(255, 255, 255, 0.8);
  display: grid;
  place-items: center;
  text-align: center;
  padding: 10%;
}

.addedtocart .subtitle {
  font-size: 1.4rem;
  font-weight: 700;
}

.addedtocart b {
  font-weight: 900;
}

.nkitinfo {
  padding: 24px;
  background: #1E1E1E;
  color: white;
  border-radius: 25px;
}

.nkitinfo .title {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 24px;
  color: white;
}

.parts-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.part-card {
  background: #2A2A2A;
  border-radius: 16px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 16px;
}

.part-image {
  width: 72px;
  height: 72px;
  background: white;
  border-radius: 12px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.part-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.part-details {
  flex: 1;
}

.part-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 4px;
}

.part-name {
  font-size: 16px;
  font-weight: 500;
  color: white;
  margin: 0;
  line-height: 1.2;
}

.part-price {
  font-size: 14px;
  color: #999;
  margin: 4px 0;
}

.part-quantity {
  font-size: 14px;
  color: white;
}

.project-cost {
  margin-top: 32px;
  background: transparent;
  padding: 0;
}

.project-cost h3 {
  font-size: 20px;
  color: #999;
  font-weight: 500;
  margin-bottom: 8px;
}

.cost-amount {
  font-size: 32px;
  font-weight: 700;
  color: white;
  margin-bottom: 4px;
}

.cost-note {
  font-size: 14px;
  color: #999;
  margin-bottom: 24px;
}

.cart-btn {
  width: 100%;
  background: #4CAF50;
  color: white;
  border: none;
  padding: 16px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.cart-btn:hover {
  background: #43A047;
}

.part-status-check svg {
  width: 24px;
  height: 24px;
}

.separator {
  text-align: center;
  color: #999;
  font-size: 16px;
  font-weight: 500;
  margin: 32px 0 24px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.separator::before,
.separator::after {
  content: '';
  flex: 1;
  height: 1px;
  background: #444;
}

.alt-components {
  margin-top: 32px;
}

.cart-toggle-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  background: #4CAF50;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.cart-toggle-btn:hover {
  background: #43A047;
}

.cart-toggle-btn.in-cart {
  background: #2A2A2A;
  border: 2px solid #4CAF50;
}

.cart-toggle-btn.in-cart:hover {
  background: #222;
}

.cart-toggle-btn svg {
  transition: transform 0.2s ease;
}

.cart-toggle-btn:hover svg {
  transform: scale(1.1);
}

.check-icon,
.plus-icon {
  width: 20px;
  height: 20px;
}

/* Animation for feedback */
@keyframes addedToCart {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
}

.cart-toggle-btn.in-cart {
  animation: addedToCart 0.3s ease;
}
</style>